<div class="vitamui-input" [class.disabled]="control.disabled">
  <button type="button" class="px-2 type-selector-trigger" [matMenuTriggerFor]="menu" [disabled]="control.disabled">
    <div class="search-icon">
      <i class="vitamui-icon vitamui-icon-search"></i>
      <i class="vitamui-icon vitamui-icon-search"></i>
    </div>
    <i class="vitamui-icon vitamui-icon-chevron-down"></i>
  </button>
  <div class="input-box focus-within-zone">
    <label>
      <span class="ellipsis">{{ placeholder() }} ({{ (_selectedType || types()[0]).label | lowercase }})</span>
      @if (isRequired()) {
        <span class="required-marker">*</span>
      }
    </label>
    <input type="text" [ngModel]="control.value?.value" (ngModelChange)="inputValueChange($event)" [disabled]="control.disabled" />
  </div>
</div>
<vitamui-form-errors [control]="control" [errorMessageMap]="errorMessageMap()"></vitamui-form-errors>
<mat-menu #menu="matMenu" class="my-1">
  @for (type of types(); track type.value; let first = $first) {
    <button
      mat-menu-item
      (click)="selectType(type)"
      [class.selected]="(first && !_selectedType) || type === _selectedType"
      [disabled]="type.disabled"
    >
      {{ type.label }}
    </button>
  }
</mat-menu>
